import { CommonModule } from '@angular/common';
import { Component, ElementRef, ViewChild, AfterViewInit, Input, WritableSignal, signal, linkedSignal, AfterViewChecked, Signal, computed } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-multi-row-text-ellipsis',
  imports: [CommonModule, TranslateModule],
  templateUrl: './multi-row-text-ellipsis.component.html',
  styleUrl: './multi-row-text-ellipsis.component.scss'
})
export class MultiRowTextEllipsisComponent implements AfterViewChecked {
  @Input() text: string | null = '';
  @ViewChild('textContainer') textContainer!: ElementRef;

  limit: number = 50;
  fullTextVisible: boolean = false;

  public readonly letterWidth = 8;
  public readonly lineHeight = 23 ;

  private _rows: WritableSignal<number> = signal(0);
  public rows: Signal<number> = computed(() => {
    let rows = Math.round(this._rows());
    if (this._rows() > rows && this._rows() < 2) {
      return 1;
    }
    return rows;
  });
  public minRows: WritableSignal<number> = linkedSignal(() => this.rows() > 2 ? 2 : this.rows());

  public expanded: WritableSignal<boolean> = signal(false);

  ngAfterViewChecked() {
    this.calculateLimit();
  }

  calculateLimit() {
    const container = this.textContainer?.nativeElement;
    if (container && this.text) {
      let rows = (this.text.length * this.letterWidth) / container.clientWidth;
      this._rows.set(rows);
    }
  }
}
